"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignsExperimentsService = void 0;
class CampaignsExperimentsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Get campaign experiments
     * @param id
     * @returns CampaignExperimentsResponse
     * @throws ApiError
     */
    getCampaignExperiments(id) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/campaigns/{id}/experiments',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Create a campaign experiment
     * @param id
     * @param requestBody
     * @returns CampaignExperimentResponse
     * @throws ApiError
     */
    createCampaignExperiment(id, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/campaigns/{id}/experiments',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Update a campaign experiment
     * @param campaignId
     * @param experimentId
     * @param requestBody
     * @returns CampaignExperimentResponse
     * @throws ApiError
     */
    updateCampaignExperiment(campaignId, experimentId, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/campaigns/{campaignId}/experiments/{experimentId}',
            path: {
                'campaignId': campaignId,
                'experimentId': experimentId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a campaign experiment
     * @param campaignId
     * @param experimentId
     * @returns CampaignExperimentResponse
     * @throws ApiError
     */
    deleteCampaignExperiment(campaignId, experimentId) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/campaigns/{campaignId}/experiments/{experimentId}',
            path: {
                'campaignId': campaignId,
                'experimentId': experimentId,
            },
        });
    }
    /**
     * Add a group to a campaign experiment
     * @param campaignId
     * @param experimentId
     * @param groupId
     * @returns CampaignExperimentResponse
     * @throws ApiError
     */
    addGroupToCampaignExperiment(campaignId, experimentId, groupId) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/campaigns/{campaignId}/experiments/{experimentId}/groups/{groupId}',
            path: {
                'campaignId': campaignId,
                'experimentId': experimentId,
                'groupId': groupId,
            },
        });
    }
    /**
     * Remove a group from a campaign experiment
     * @param campaignId
     * @param experimentId
     * @param groupId
     * @returns CampaignExperimentResponse
     * @throws ApiError
     */
    removeGroupFromCampaignExperiment(campaignId, experimentId, groupId) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/campaigns/{campaignId}/experiments/{experimentId}/groups/{groupId}',
            path: {
                'campaignId': campaignId,
                'experimentId': experimentId,
                'groupId': groupId,
            },
        });
    }
    /**
     * Update the eligibility filters of a campaign experiment
     * @param campaignId
     * @param experimentId
     * @param requestBody
     * @returns CampaignGroupEligibilityResponse
     * @throws ApiError
     */
    updateCampaignExperimentEligibility(campaignId, experimentId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/campaigns/{campaignId}/experiments/{experimentId}/eligibility',
            path: {
                'campaignId': campaignId,
                'experimentId': experimentId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Enable the eligibility filters of a campaign experiment
     * @param campaignId
     * @param experimentId
     * @returns CampaignGroupEligibilityResponse
     * @throws ApiError
     */
    enableCampaignExperimentEligibility(campaignId, experimentId) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/campaigns/{campaignId}/experiments/{experimentId}/enable',
            path: {
                'campaignId': campaignId,
                'experimentId': experimentId,
            },
        });
    }
    /**
     * Disable the eligibility filters of a campaign experiment
     * @param campaignId
     * @param experimentId
     * @returns CampaignGroupEligibilityResponse
     * @throws ApiError
     */
    disableCampaignExperimentEligibility(campaignId, experimentId) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/campaigns/{campaignId}/experiments/{experimentId}/disable',
            path: {
                'campaignId': campaignId,
                'experimentId': experimentId,
            },
        });
    }
}
exports.CampaignsExperimentsService = CampaignsExperimentsService;
